import React, { PureComponent } from 'react';
import styled from 'styled-components';

import Header from '~/components/Header';
import Footer from '~/components/Footer';
import Visualisation from '~/components/Visualisation';
import ChartControls from '~/components/ChartControls';
import IncomeCalculator from '~/components/IncomeCalculator';

const AppWrapper = styled.div`
  height: 100%;
  position: relative;
  max-width: 700px;
  margin: 0 auto;
  padding: 0 15px;
  font-size: 13px;
`;

class App extends PureComponent {
  render() {
    return (
      <AppWrapper className="appwrapper">
        <Header />
        <IncomeCalculator />
        <ChartControls />
        <Visualisation />
        <Footer />
      </AppWrapper>
    );
  }
}

export default App;
